import { action } from 'easy-peasy';
import { IActionResetAiSettings } from '../types';

const resetAiClinicSettings: IActionResetAiSettings = action(state => {
  state.currentClinic = null;
});

export default resetAiClinicSettings;
